import React, { useState } from 'react';
import ZpButton from 'components/zpButton';
import classes from './index.module.css';
import Image from 'next/image';
import EmailBox from './EmailBox';

const MiniBlurredGate = () => {
  const [show, setShow] = useState(true);
  return (
    <div className={classes.miniBlurContainer}>
      <h4 className="d-flex align-items-center mb-0">
        <Image src="/ui-router/images/lock.svg" width={20} height={20} />
        <span className="ml-2 openSansBlackBold">Registerd Users Only</span>
      </h4>
      <p className="my-1">Get free access to all Zippia content</p>
      {show ? (
        <ZpButton isFullWidth size="big" className="mt-2" onClick={() => setShow(false)}>
          Sign Up
        </ZpButton>
      ) : (
        <div className="mt-2">
          <EmailBox buttonContent={<div className={classes.owlNext} />} />
        </div>
      )}
    </div>
  );
};

export default MiniBlurredGate;
